import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import { preset } from './preset'

Vue.use(Vuetify);

export default new Vuetify({
  preset,
});
